import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.div`
  display: grid;
  grid-gap: ${({ theme }) => theme.spacer}px;
  grid-template-columns: 1fr;

  ${({ theme }) => theme.mediaQueries.large} {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: ${({ theme }) => theme.spacer * 2}px;
  }

  &.HelpButton {
    ${({ theme }) => theme.mediaQueries.large} {
      grid-template-columns: repeat(2, 1fr);
      grid-gap: ${({ theme }) => theme.spacer * 2}px;
    }
  }
`;

const OutlinedLinksGrid = ({ className, children }) => {
  const classes = ["OutlinedLinksGrid"];

  if (children && children.type && children.type.displayName === 'OutlinedMoreHelp') {
    classes.push('HelpButton');
  }

  if (className) classes.push(className);

  return <Wrapper className={classes.join(" ")}>{children}</Wrapper>;
};

OutlinedLinksGrid.displayName = "OutlinedLinksGrid";

OutlinedLinksGrid.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

OutlinedLinksGrid.defaultProps = {
  className: null,
};

export default OutlinedLinksGrid;
